// extracted by mini-css-extract-plugin
export default {"wrapper":"content-title_wrapper__ktOYz"};